import AppDropdown from '@/components/AppDropdown.vue';
import DownloadIcon from "@/components/icons/DownloadIcon.vue";
import CSVIcon from "@/components/icons/CSVIcon.vue";
import SheetIcon from "@/components/icons/SheetIcon.vue";
import WrapWithPopover from "@/components/shared/WrapWithPopover.vue";
import FlexRow from "@/components/FlexRow.vue";
import AppPopover from "@/components/AppPopover";
import AppIcon from '@/components/AppIcon.vue';
export default {
  name: 'ViewExporter',
  components: {
    AppDropdown,
    DownloadIcon,
    CSVIcon,
    SheetIcon,
    WrapWithPopover,
    FlexRow,
    AppPopover,
    AppIcon
  },
  props: {
    placement: [String, null]
  }
};